<script lang="ts" setup>
// import generationPPtJson from "../useTemp/index";
import { onBeforeUnmount } from "vue";
import { pptNode, slideJson } from "../use/data";
import { iframeSrc, iframePostMessage, slidesIframe } from "../use/iframe";
import { goBack } from "../use/methods";
import useStore from "@/stores/publicStore";
import { showMessageBoxByType } from "@/components/content/MessageBox/messageBox";
import { handleCreatePPT, handleSavePPT } from "../use/edit";
import { _postSavePPT } from "@/api";
import { storeToRefs } from "pinia";
import PPTStore from "@/stores/PPTStore";

const { isVip, tryOut } = storeToRefs(useStore());
const { curentPPT } = storeToRefs(PPTStore());

//window.addEventListener事件监听回调
const messageHandler = async (e: any) => {
  const data = e.data;
  switch (data.type) {
    case "slideReady":
      const arr = slideJson.value;
      iframePostMessage("changeSlide", {
        arr: JSON.parse(JSON.stringify(arr)),
        title: pptNode.value[0].title || curentPPT.value.name || "PPTTEST",
      });
      break;
    case "slideBack":
      curentPPT.value = null;
      goBack();
      break;
    case "export":
      if (!isVip.value && tryOut.value) {
        showMessageBoxByType("downloadPPT");
      } else {
        tryOut.value = true;
        iframePostMessage("export");
      }
      break;
    case "createPPT":
      await handleCreatePPT(data, curentPPT);
      iframePostMessage("savePPT");
      break;
    case "savePPT":
      handleSavePPT(data, curentPPT);
      break;
    default:
      break;
  }
};

window.addEventListener("message", messageHandler);

onBeforeUnmount(() => {
  // 在组件卸载之前移除监听器
  window.removeEventListener("message", messageHandler);
});
</script>
<!--  -->
<template>
  <div>
    <iframe
      :src="iframeSrc"
      class="fixed top-0 bottom-0 right-0 w-full h-full border-none m-0 p-0 overflow-hidden z-10"
      ref="slidesIframe"
      id="slidesIframe"
    ></iframe>
  </div>
</template>

<style lang="scss" scoped></style>
